import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      $gm_error_message: 'errors/getErrorMessage'
    })
  },
  methods: {
    ...mapActions({
      $gm_error_setMessage: 'errors/setErrorMessage',
      $gm_error_setShow: 'errors/setShowError'
    }),
    $gm_error_show(message) {
      if (message) {
        this.$gm_error_setMessage(message);
      }

      this.$gm_error_setShow(true);
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/mixins/global/error.js